import React,{useState} from 'react';
import logo from './Cafe_Logo.svg';
import instaLogo from './instagram.png'
import lineLogo from './line.png'
import facebookLogo from './facebook.svg'
import hotelLogo from './Sinkiat1.svg'
import foodpandaLogo from './foodpanda.jpeg'
// import { InstagramMedia } from 'react-instagram-media'
import {useInstagramFeed} from 'use-instagram-feed'
import './App.css';
/* eslint-disable jsx-a11y/anchor-is-valid */

function App() {

  const [language,setLanguage] = useState('TH');

  let photos = useInstagramFeed({
    userId: "43940795831",
    thumbnailWidth: 640,
    photoCount: 9,
  })

  return (
    <div className="App">
      <div className="NavBar">
        <div className='ma2'>
          <a href = '\' className='dim'>{language === 'TH' ? 'ย้อนกลับ' : 'Go Back'}</a>
        </div>
        <div>
          {language === 'TH' ? 'สินเกียรติธานี คาเฟ่' : 'Sinkiat Thani Cafe'}
        </div>
        
          {
            language === 'TH' ?  
              <div className='ma2'><a className='dim' href = "#" onClick={()=>setLanguage('TH')}><b>ภาษาไทย</b></a>  |  <a className='dim' href = "#" onClick={()=>setLanguage('EN')}>English</a></div>
              : <div className='ma2'><a className='dim' href = "#" onClick={()=>setLanguage('TH')}>ภาษาไทย</a>  |  <a className='dim' href = "#" onClick={()=>setLanguage('EN')}><b>English</b></a></div>
          }
        
      </div>
      <header className="App-header">
        <img src={logo} className="App-logo" alt="logo" />
        <div className='Menu' style={{width: '70%'}}>
        <div className='InstagramFeed' style={{width: '100%'}}>
          {photos &&
            photos.map(({ id, caption, src, width, height, url }) => (
              <div key={id} className='InstagramFeedItem card grow bw2 shadow-5 bg-white br3 pa2 ma2'>
                  <a target="_blank" rel="noopener noreferrer" key={id} href={url} className='no-underline'>
                    <img src={src} alt={caption} className=''/>
                    <div className='flex flex-column justify-center items-center'>
                        <img src={instaLogo} alt='instagram' width='10%' height='10%' className='ma2'/> 
                        <p className='f4 fw1 ma0'>@sinkiatcafe</p>
                        <p className='f5 black' style={{lineHeight: '1.5em',height: '3em', width: '90%',whiteSpace: 'nowrap',overflow: 'hidden',textOverflow: 'ellipsis'}}>{caption}</p>
                    </div>
                  </a>
              </div>
            ))}
        </div>
          <table className='MenuTable pa2 w-100'>
            <thead>
              <tr style={{"color": '#D60666'}}>
                <td>{language === 'TH' ? 'เมนู' : 'Menu'}</td>
                <td>{language === 'TH' ? 'ร้อน' : 'Hot'}</td>
                <td>{language === 'TH' ? 'เย็น' : 'Cold'}</td>
                <td>{language === 'TH' ? 'ปั่น' : 'Blended'}</td>
                <td>{language === 'TH' ? 'ไอศกรีม โฟลต' : 'Icecream Float'}</td>
              </tr>
            </thead>
            <tbody>
               <tr>
                <td>{language === 'TH' ? 'อเมริกาโน่' : 'Americano'}</td>
                <td>35.-</td>
                <td>55.-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'เอสเพรสโซ่' : 'Espresso'}</td>
                <td>40.-</td>
                <td>65.-{language === 'TH' ? ' (ใส่นม)' : ' (with milk)'}</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'คาปูชิโน่' : 'Cappuccino'}</td>
                <td>45.-</td>
                <td>65.-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'พิคโคโล่ ลาเต้' : 'Piccolo Latte'}</td>
                <td>45.-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'ลาเต้' : 'Café Latte'}</td>
                <td>45.-</td>
                <td>65.-</td>
                <td>75.-</td>
                <td>80.-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'มัคคิอาโต้' : 'Macchiato'}</td>
                <td>45.-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'แฟลต ไวท์' : 'Flat White'}</td>
                <td>50.-</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'มอคค่า' : 'Café Mocha'}</td>
                <td>50.-</td>
                <td>70.-</td>
                <td>80.-</td>
                <td>85.-</td>
              </tr>
               <tr>
                <td>{language === 'TH' ? 'ลาเต้ มัคคิอาโต้' : 'Latte Macchiato'}</td>
                <td>55.-</td>
                <td>75.-</td>
                <td>-</td>
                <td>-</td>
              </tr>
               <tr>
                <td>{language === 'TH' ? 'คาลาเมล มัคคิอาโต้' : 'Caramel Macchiato'}</td>
                <td>65.-</td>
                <td>85.-</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'เดอร์ตี้ คอฟฟี่' : 'Dirty Coffee'}</td>
                <td>-</td>
                <td>65.-{language === 'TH' ? ' (แช่เย็น)' : ' (Chilled)'}</td>
                <td>-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'ช็อกโกแลต' : 'Chocolate'}</td>
                <td>45.-</td>
                <td>65.-</td>
                <td>75.-</td>
                <td>80.-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'ชาเขียวนม' : 'Milk Green Tea'}</td>
                <td>45.-</td>
                <td>65.-</td>
                <td>75.-</td>
                <td>80.-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'ชาไทย' : 'Thai Milk Tea'}</td>
                <td>45.-</td>
                <td>65.-</td>
                <td>75.-</td>
                <td>80.-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'นมชมพู' : 'Pink Milk'}</td>
                <td>45.-</td>
                <td>65.-</td>
                <td>75.-</td>
                <td>80.-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'มัทฉะ ลาเต้' : 'Matcha Latte'}</td>
                <td>55.-</td>
                <td>75.-</td>
                <td>85.-</td>
                <td>90.-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'มัทฉะ คาเฟ่ ลาเต้' : 'Matcha Cafe Latte'}</td>
                <td>-</td>
                <td>75.-</td>
                <td>85.-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'โอรีโอ้ ปั่น' : 'Oreo Shake'}</td>
                <td>-</td>
                <td>-</td>
                <td>75.-</td>
                <td>-</td>
              </tr>
              <tr>
                <td>{language === 'TH' ? 'อัฟโฟกาโต้' : 'Affogato'}</td>
                <td>-</td>
                <td>-</td>
                <td>-</td>
                <td>65.-</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className='updatedDate ma3'>
          2021 - 01 - 29
        </div>
      </header>
      <footer className='footerDiv'>
        <a className='hotelLogo no-underline' target="_blank" rel="noopener noreferrer" href='https://www.sinkiathotel.com' alt='Sinkiat Thani Hotel'>
          <img src={hotelLogo} alt='Sinkiat Thani Hotel' />
        </a>
        <div className='flex flex-column flex-start'>
          <div className='f4 ml0 black'>{language === 'TH' ? 'โทรศัพท์/สั่งเครื่องดื่ม' : 'Tel./Order Now'}</div>
          <div className='f2'>074-711-336</div>
          <div className='f2'>091-847-1057</div>
        </div>
       
        <div className='flex flex-column f3 contactDetail'>
          <div className='flex items-center'><img src={lineLogo} alt='line' width="10%" className='ma2'/><a target="_blank" rel="noopener noreferrer" href='https://line.me/ti/p/~sinkiathotel' alt='line' className='no-underline'>sinkiathotel</a></div>
          <div className='flex items-center'><img src={instaLogo} alt='instagram' width="10%" className='ma2'/><a target="_blank" rel="noopener noreferrer" href='https://www.instagram.com/sinkiatcafe/' alt='instagram' className='no-underline'>@sinkiatcafe</a></div>
          <div className='flex items-center'><img src={facebookLogo} alt='facebook' width="10%" className='ma2'/><a target="_blank" rel="noopener noreferrer" href='https://www.facebook.com/sinkiathotel/' alt='facebook' className='no-underline'>sinkiathotel</a></div>
          <div className='flex items-center'><img src={foodpandaLogo} alt='facebook' width="10%" className='ma2'/><a target="_blank" rel="noopener noreferrer" href='https://www.foodpanda.co.th/restaurant/k3nc/' alt='foodpanda' className='no-underline'>{language === 'TH' ? 'สินเกียรติธานี คาเฟ่' : 'Sinkiat Thani Café'}</a></div>
        </div>
      </footer>
    </div>
  );
}

export default App;
